import { render, staticRenderFns } from "./ImprestCashComment.vue?vue&type=template&id=a073ec92&scoped=true"
import script from "./ImprestCashComment.vue?vue&type=script&lang=js"
export * from "./ImprestCashComment.vue?vue&type=script&lang=js"
import style0 from "./ImprestCashComment.vue?vue&type=style&index=0&id=a073ec92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a073ec92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VDivider,VList,VListItem,VListItemContent,VListItemSubtitle})
